var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { staticClass: "justify-center" },
        [
          _c("v-col", { staticClass: "d-flex justify-center" }, [
            _c(
              "div",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "link-light",
                    attrs: { to: _vm.agreementRoute.terms },
                  },
                  [_vm._v(_vm._s(_vm.agreementResource.terms))]
                ),
                _vm._v(" / "),
                _c(
                  "router-link",
                  {
                    staticClass: "link-light",
                    attrs: { to: _vm.agreementRoute.privacy },
                  },
                  [_vm._v(_vm._s(_vm.agreementResource.privacy))]
                ),
                _vm._v(" / "),
                _c(
                  "router-link",
                  {
                    staticClass: "link-light",
                    attrs: { to: _vm.quickytoolsRoute.credits },
                  },
                  [_vm._v(_vm._s(_vm.commonResource.credits))]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }